import React, { useEffect, lazy } from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { ChevronRight, FlaskConical } from 'lucide-react';
export function ProductOptionPatterns() {
  useScreenInit();
  useEffect(() => {
    const previous = document.title;
    document.title = 'Product Option Patterns | MidAtlantic Mailboxes';
    return () => {
      document.title = previous;
    };
  }, []);
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1680" data-mp="2mk0u8gt7onok">
      <TopBar data-id="element-1681" data-mp="3jymseno35yar" />
      <Header data-id="element-1682" data-mp="3jyd557ufe58r" />
      <Navigation data-id="element-1683" data-mp="3jywieb94s5gg" />

      <main className="flex-grow" data-id="element-1684" data-mp="3jzemtv5y5pzg">
        <section className="bg-white border-b border-brand-border py-10 lg:py-12" data-id="element-1685" data-mp="3k0hhme6e4ckn">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1686" data-mp="3f5tog20fytzq">
            {/* Breadcrumbs */}
            <nav className="flex text-sm text-gray-500 mb-6 overflow-x-auto hide-scrollbar whitespace-nowrap pb-2" data-id="element-1687" data-mp="3ad6x8q9qwvaz">
              <ol className="flex items-center space-x-2" data-id="element-1688" data-mp="3fdumb6eez22k">
                <li data-id="element-1689" data-mp="30lu7q5bf6h84">
                  <a href="/Home.html" className="hover:text-brand-maroon transition-colors" data-id="element-1690" data-mp="30mc9fhgupnnf">
                    Home
                  </a>
                </li>
                <li data-id="element-1691" data-mp="2roa08emyrop2">
                  <ChevronRight size={14} className="text-gray-400" data-id="element-1692" data-mp="2vniwpr9e20ob" />
                </li>
                <li data-id="element-1693" data-mp="2hnzpd0oeitd2">
                  <span className="text-gray-400" data-id="element-1694" data-mp="2hoj6if689dq1">Resources</span>
                </li>
                <li data-id="element-1695" data-mp="2mmugqr0fpq8s">
                  <ChevronRight size={14} className="text-gray-400" data-id="element-1696" data-mp="2mmb0deqfn9wv" />
                </li>
                <li className="text-brand-charcoal font-medium" data-id="element-1697" data-mp="fw4utxua15i2">
                  Product Option Patterns
                </li>
              </ol>
            </nav>

            <div className="flex items-start gap-4" data-id="element-1698" data-mp="ktdczyffd9jb">
              <div className="hidden sm:flex w-12 h-12 rounded-xl bg-brand-goldWash border border-brand-gold/30 text-brand-maroon items-center justify-center shrink-0" data-id="element-1699" data-mp="jflnus75dtr7">
                <FlaskConical size={24} strokeWidth={1.75} data-id="element-1700" data-mp="9g4k4gbghpxv" />
              </div>
              <div className="max-w-3xl" data-id="element-1701" data-mp="9i7j3pul6teq">
                <h1 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-3" data-id="element-1702" data-mp="4icw3xdxmnyy">
                  Product Option Pattern Library
                </h1>
                <p className="text-lg text-brand-muted leading-relaxed" data-id="element-1703" data-mp="x68pot87fzri">
                  A review prototype for exploring how product options can be
                  presented and handled across MidAtlantic product pages.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Embedded prototype */}
        <section className="py-8 lg:py-12" data-id="element-1704" data-mp="1kx4d7e5mo8sy">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1705" data-mp="1g4tak3ji68wp">
            <div className="bg-white rounded-xl border border-brand-border overflow-hidden shadow-sm" data-id="element-1706" data-mp="1g39x0kp8ebym">
              <iframe title="MidAtlantic product option pattern library" src="https://codex.websiteforge.net/MidAt-product-options/" loading="lazy" sandbox="allow-scripts allow-same-origin allow-popups" className="w-full block border-0 h-[calc(100vh-180px)] min-h-[640px]" data-id="element-1707" data-mp="1of1umv7sfa6n" />
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1708" data-mp="27aiefh0x33pe" />
      <MobileStickyBar data-id="element-1709" data-mp="2bdolurzrn0xg" />
    </div>;
}